import { Field } from '@yes.technology/react-toolkit'
import { useMemo } from 'react'
import { FieldSettings } from 'shared/types'
import {
  isSituationField,
  situationInitialValue
} from 'shared/utils/specialRelationFields/specialRelationFields'
import {
  FieldValues,
  FilterSectionLayout
} from 'site/Renderer/components/FilterFields/types'
import { findSectionLayoutField } from './utils/findSectionLayoutField'

type UseInitialFieldValuesProps = {
  classifiedFields: (Field | undefined)[][]
  fieldSettings?: FieldSettings
  sectionsLayout?: FilterSectionLayout[]
}

const useInitialFieldValues = ({
  classifiedFields,
  fieldSettings,
  sectionsLayout
}: UseInitialFieldValuesProps) => {
  const initialFieldValues: FieldValues = useMemo(() => {
    const values: FieldValues = {}

    for (const field of classifiedFields.flat()) {
      if (field && field.uuid) {
        const fieldSetting = fieldSettings?.[field.column_json]
        const layoutField = findSectionLayoutField(sectionsLayout, field.uuid)

        values[field.column_json] = {
          operator:
            fieldSetting?.operator ||
            layoutField?.datafield?.operator ||
            (field.type === 'RELATION' ? 'in' : 'eq'),
          value: isSituationField(field?.column_json)
            ? [situationInitialValue]
            : '',
          type: field.type
        }
      }
    }

    return values
  }, [classifiedFields, fieldSettings, sectionsLayout])

  return initialFieldValues
}

export default useInitialFieldValues
